export const AmplitudeRequiredCookieConsentGroup = 'CX001' // Customer Experience Improvement
